import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { 
    ClipboardList, 
    Users, 
    UserPlus, 
    Shield, 
    Palmtree,
    Settings,
    ChevronRight,
    UserCircle,
    LogOut,
    Droplets,
    Calculator
} from 'lucide-react';

export const MorePage = () => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    const menuItems = [
        { to: '/orders', icon: ClipboardList, label: 'Alle Aufträge', description: 'Alle Aufträge verwalten' },
        { to: '/customers', icon: Users, label: 'Kunden', description: 'Kundenverwaltung' },
        { to: '/employees', icon: UserPlus, label: 'Mitarbeiter', description: 'Mitarbeiter verwalten' },
        { to: '/payroll', icon: Calculator, label: 'Stundenabrechnung', description: 'Stunden ans Lohnbüro melden' },
        { to: '/admins', icon: Shield, label: 'Admins', description: 'Administrator-Konten' },
        { to: '/vacation', icon: Palmtree, label: 'Urlaubsverwaltung', description: 'Urlaubsanträge' },
        { to: '/irrigation', icon: Droplets, label: 'Bewässerungssteuerung', description: 'Hide and Grow Automation' },
        { to: '/settings', icon: Settings, label: 'Einstellungen', description: 'System-Einstellungen' },
        { to: '/profile', icon: UserCircle, label: 'Profil', description: 'Mein Profil & Passwort' },
    ];

    return (
        <div className="p-4 pb-24 space-y-4" data-testid="more-page">
            {/* User Info */}
            <div className="flex items-center gap-3 p-4 bg-card rounded-lg border">
                <div className="h-12 w-12 rounded-full bg-primary flex items-center justify-center text-primary-foreground font-semibold text-lg">
                    {user?.name?.charAt(0) || 'U'}
                </div>
                <div className="flex-1">
                    <p className="font-medium">{user?.name}</p>
                    <p className="text-sm text-muted-foreground">{user?.email}</p>
                </div>
            </div>

            <h1 className="text-xl font-bold">Weitere Optionen</h1>
            
            <div className="space-y-2">
                {menuItems.map((item) => (
                    <Link key={item.to} to={item.to}>
                        <Card className="hover:bg-muted/50 transition-colors">
                            <CardContent className="p-4 flex items-center gap-4">
                                <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center">
                                    <item.icon className="h-5 w-5 text-primary" />
                                </div>
                                <div className="flex-1">
                                    <p className="font-medium">{item.label}</p>
                                    <p className="text-sm text-muted-foreground">{item.description}</p>
                                </div>
                                <ChevronRight className="h-5 w-5 text-muted-foreground" />
                            </CardContent>
                        </Card>
                    </Link>
                ))}
            </div>

            {/* Logout Button */}
            <div className="pt-4">
                <Button 
                    variant="outline" 
                    className="w-full justify-center gap-2 h-12 text-destructive border-destructive/30 hover:bg-destructive/10"
                    onClick={handleLogout}
                    data-testid="logout-btn-mobile"
                >
                    <LogOut className="h-5 w-5" />
                    Abmelden
                </Button>
            </div>
        </div>
    );
};

export default MorePage;
